import * as Yup from 'yup';
import { errorMessages } from '../../../../constants/validationMessages';
export default Yup.object().shape({
    nickname: Yup.string().required(errorMessages.requiredField),
    firstName: Yup.string().required(errorMessages.requiredField),
    lastName: Yup.string().required(errorMessages.requiredField),
}, []);
